import { ethers } from "ethers";

// General function to get balance for any Ethereum compatible network
const getBalanceForNetwork = async (address: string, networkUrl: string): Promise<number> => {
  try {
    if (!networkUrl) {
      throw new Error("⚠ Network URL is not provided");
    }

    // Create a Web3 provider for the specified network
    const provider = new ethers.JsonRpcProvider(networkUrl);

    // Fetch the balance in wei (smallest unit)
    const balance = await provider.getBalance(address);

    // Convert the balance from wei to ether
    return parseFloat(ethers.formatEther(balance));
  } catch (err) {
    console.error(err);
    throw new Error('⚠ Failed to fetch balance.');
  }
};

// Get balance for Ethereum network
export const getBalanceEthereum = async (address: string): Promise<number> => {
  const networkUrl = 'https://mainnet.infura.io/v3/61518736fce84c9d9081dfe82b904b26'; // Ethereum Mainnet RPC URL (replace with your Infura or Alchemy URL)
  return getBalanceForNetwork(address, networkUrl);
};

// Get balance for Base network
export const getBalanceBase = async (address: string): Promise<number> => {
  const networkUrl = 'https://mainnet.base.org'; // Base Network RPC URL (replace with actual Base RPC URL)
  return getBalanceForNetwork(address, networkUrl);
};

// Get balance for Arbitrum network
export const getBalanceArbitrum = async (address: string): Promise<number> => {
  const networkUrl = 'https://arb1.arbitrum.io/rpc'; // Arbitrum Mainnet RPC URL (replace with actual Arbitrum RPC URL)
  return getBalanceForNetwork(address, networkUrl);
};

// Get balance for BNB (Binance Smart Chain) network
export const getBalanceBNB = async (address: string): Promise<number> => {
  const networkUrl = 'https://bsc-dataseed1.binance.org:443'; // Binance Smart Chain RPC URL
  return getBalanceForNetwork(address, networkUrl);
};

// Get balance for Optimism network
export const getBalanceOptimism = async (address: string): Promise<number> => {
  const networkUrl = 'https://mainnet.optimism.io'; // Optimism Mainnet RPC URL
  return getBalanceForNetwork(address, networkUrl);
};
